module.exports = __webpack_public_path__ + "img/button-delete.2b0f879e.svg";